<!DOCTYPE html>
<html lang="en">

<head>
	<script type="application/ld+json">

		{
		  "@context": "https://schema.org/",
		  "@type": "Organization",
		  "name": "Backseat Trader",
		  "url": "https://www.backseat-trader.com/",
		  "image": "https://www.backseat-trader.com/assets/img/Cosmic%20Algorithm%20Brand%20Assets-46.png"
		}
		
		</script>
	<meta charset="utf-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">

	<title>Backseat Trader's algorithm on the eToro trading platform</title>
	<script src="js/wow.js"></script>
	<script>
		new WOW().init();
	</script>

	<link rel="shortcut icon" type="image/x-icon" href="assets/img/favicon.ico">
	<!--<link rel="stylesheet" type="text/css" href="assets/css/bundle.css">-->

	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="">
	<link
		href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Poppins:wght@500;700&family=Quicksand:wght@300;400;500;700&family=Roboto:wght@400;500&display=swap"
		rel="stylesheet">
	<script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

</head>
<noscript>
	<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0" class="hideIt"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->

<body>
	<div class="sticky">
		<header class="header">
			<div class="shell shell--size-1">
				<div class="header__inner">
					<a href="/home/fxcm#home" class="logo">
						<img src="assets/img/Cosmic Algorithm Brand Assets-10.png" alt="Cosmic Algorithm Logo"
							loading="lazy">
					</a>

					<div class="header__aside">
						<nav class="nav hidden-xs">
							<ul style="list-style-type: none;">
								<li>
									<a href="/home/fxcm#home">Home</a>
								</li>

								<li>
									<a href="/home/fxcm#about">About</a>
								</li>
								<!-- Home / About / Academy / Newsletter / Brochure -->
								<li>
									<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
									<a [routerLink]="['/academy']" (click)="capturePos()">Academy</a>

								</li>

								<li>
									<!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->

									<a href="/home/fxcm#performance">Performance</a>
								</li>

								<li>

									<a href="/home/fxcm#brochure">Brochure</a>
								</li>

							</ul>
						</nav><!-- /.nav -->

						<div class="header__actions">

							<button class="btn btn--secondary hidden-xs"><a style="all: unset;"
									[routerLink]="['/platform/profiles']" (click)="capturePos()">My Profile</a></button>

							<a [routerLink]="['/platform/live']" class="btn btn--size-1" (click)="capturePos()">Live</a>

							<a [routerLink]="['/platform/profiles']"
								class="btn btn--secondary btn--xs hidden visible-xs-inline-block">
								<img src="assets/img/svg/ico-profile.svg" alt="Click here for your profile"
									loading="lazy" (click)="capturePos()">
							</a>


						</div><!-- /.header__actions -->

					</div><!-- /.header__aside -->
				</div><!-- /.header__inner -->
			</div><!-- /.shell -->
		</header><!-- /.header -->
	</div>
	<script src="assets/vendor/jquery-3.6.0.min.js"></script>
	<script src="assets/js/bundle.js"></script>
	<div class="wrapper">

		<div class="hero" id="home">
			<div class="shell shell--size-2">
				<nav class="nav hidden visible-xs-block">
					<ul>
						<li>
							<a href="/home/fxcm#home">Home</a>
						</li>

						<li>
							<a href="/home/fxcm#about">About</a>
						</li>
						<!-- Home / About / Academy / Newsletter / Brochure -->
						<li>
							<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
							<a [routerLink]="['/academy']" (click)="capturePos()">Academy</a>

						</li>

						<li>
							<!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->

							<a href="/home/fxcm#performance">Performance</a>
						</li>

						<li>

							<a href="/home/fxcm#brochure">Brochure</a>
						</li>

					</ul>
				</nav><!-- /.nav -->
				<div class="hero__media">
					<button data-bs-toggle="modal" data-bs-target="#myModal" style="    
					background: none;
					border: none;
					padding: 0;
					width: 100%;
					height: 100%;" *ngIf="mobile">

						<div class="hero__image heroImg"></div><!-- /.hero__image -->

						<p class="hero__play js-play" target="_blank">
							<img src="assets/img/svg/ico-play.svg" alt="Play button">
						</p>
						<!-- /.hero__media -->
					</button>
					<button data-bs-toggle="modal" data-bs-target="#myModal" *ngIf="!mobile">

						<div class="hero__image heroImg"></div><!-- /.hero__image -->

						<p class="hero__play js-play" target="_blank">
							<img src="assets/img/svg/ico-play.svg" alt="Play button">
						</p>
						<!-- /.hero__media -->
					</button>
				</div>

				<div class="hero__content" *ngIf="!mobile">
					<img src="../../assets/img/1280px-FXCM_logo.svg.png" style="width: 50%; margin-bottom: 11%" />
					<h1 id="title" class="simplifiedDesk">Leaders in zero-commmision trading platforms</h1>

					<ul>
						<li class="wow fadeInUp" data-wow-delay=".5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Deposit & trade crypto
						</li>

						<li class="wow fadeInUp" data-wow-delay="1.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy" />

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Trading solutions and resources for all experience levels
						</li>

						<li class="wow fadeInUp" data-wow-delay="2.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							World class customer support
						</li>
					</ul>
					<!-- <div style="width:100%; text-align: center;">					
						<a [routerLink]="['/join-us']" class="btn joinUsBtn" rel="noopener noreferrer"
							id="homeJoinUs1" (click)="capturePos()">Join us on eToro</a><br/><br/>
							<div style="font-size:smaller">
								Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.
							</div>
					</div> -->
				</div><!-- /.hero__content -->
				<div class="hero__content" *ngIf="mobile">

					<h1 id="title" class="simplifiedMob"><img src="../../assets/img/1280px-FXCM_logo.svg.png"
							style="width: 50%" /><br />Leaders in zero-commmision trading platforms</h1>

					<ul>
						<li class="wow fadeInUp" data-wow-delay=".5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Deposit & trade crypto
						</li>

						<li class="wow fadeInUp" data-wow-delay="1.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Trading solutions and resources for all experience levels
						</li>

						<li class="wow fadeInUp" data-wow-delay="2.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							World class customer support
						</li>
					</ul>
				</div><!-- /.hero__content -->
			</div><!-- /.shell -->
		</div><!-- /.hero -->
		<!-- <div style="    
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;">
			<section class="section section--primary">
				<div class="shell shell--size-2">
					<div class="row equal-cols gx-5">
						<div class="col">
							<a href="https://cosmic-algorithm.ie/" style="text-decoration:none; width:100%;">
								<div class="cosmicBSTLogos">
									<img src="../../assets/img/IBKR-Mobile.png" />
								</div>
							</a>
						</div>

						<div class="col">
							<a href="https://backseat-trader.com/" style="text-decoration:none; width:100%;">
								<div class="cosmicBSTLogos" style="margin-top:0; margin-bottom:0;">
									<img src="../../assets/img/Etoro_logo.svg.png" />
								</div>
							</a>
						</div>
					</div>


				</div>
			</section>
		</div> -->
		<span id="threeReasons"></span>
		<section class="section section--primary">
			<div class="shell shell--size-4">
				<div class="section__background"></div><!-- /.section__background -->

				<div class="section__head">
					<h6>3 reasons to pick</h6>

					<h2>Why Cosmic Algorithm?</h2>
				</div><!-- /.section__head -->

				<ul class="list-services" id="about" *ngIf="mobile">
					<li class="wow fadeInUp" data-wow-delay=".5s">
						<img src="assets/img/svg/ico-service-1.svg" alt="Service 1" loading="lazy">

						<p class="servicesFontSize">Performance driven algorithm</p>
					</li>

					<li class="wow fadeInUp" data-wow-delay="1.5s">
						<img src="assets/img/svg/ico-service-2.svg" alt="Service 2" loading="lazy">

						<p class="servicesFontSize">Simple to use in one click</p>
					</li>

					<li class="wow fadeInUp" data-wow-delay="2.5s">
						<img src="assets/img/svg/ico-service-3.svg" alt="Service 3" loading="lazy">

						<p class="servicesFontSize">Well curated portfolio</p>
					</li>
				</ul><!-- /.list-services -->

				<ul class="list-services" *ngIf="!mobile">
					<li class="wow fadeInUp" data-wow-delay=".5s">
						<img src="assets/img/svg/ico-service-1.svg" alt="Service 1" loading="lazy">

						<p class="servicesFontSize">Performance driven algorithm</p>
					</li>

					<li class="wow fadeInUp" data-wow-delay="1.5s">
						<img src="assets/img/svg/ico-service-2.svg" alt="Service 2" loading="lazy">

						<p class="servicesFontSize">Simple to use in one click</p>
					</li>

					<li class="wow fadeInUp" data-wow-delay="2.5s">
						<img src="assets/img/svg/ico-service-3.svg" alt="Service 3" loading="lazy">

						<p class="servicesFontSize">Well curated portfolio</p>
					</li>
				</ul><!-- /.list-services -->
				<div class="section__foot" id="about" *ngIf="!mobile">
					<div class="section__foot-background"></div><!-- /.section__foot-background -->

					<h6>Live Traded System</h6>

					<h5 class="colorBlack">This Algorithm is based on Risk / Return Models which range from 15-45% gain
						rates, annually.</h5>

				</div><!-- /.section__foot -->
				<div class="section__foot" *ngIf="mobile">
					<div class="section__foot-background"></div><!-- /.section__foot-background -->

					<h6>Live Traded System</h6>

					<h5 class="colorBlack">This Algorithm is based on Risk / Return Models which range from 15-45% gain
						rates, annually.</h5>

				</div><!-- /.section__foot -->
			</div><!-- /.shell -->
		</section><!-- /.section -->
		<div *ngIf="!mobile"><br /><br /></div>
		<section class="section-image">
			<div class="shell">
				<div class="section__image imageSection"></div>
				<!-- /.section__image -->

				<div class="section__content wow fadeInUp">
					<img src="assets/img/svg/ico-award.svg" alt="Award" loading="lazy" />


					<h3 class="howItWorks">How it works
						<a (click)="etoroInf(6)" id="HowItWorks">
							<i [class.hovered]="scrolledToElement.reachedHowItWorks"
								class="fa-solid fa-circle-info fa-lg howItWorksi" placement="top" gbTooltip="Read More"
								tooltipClass="toolTips" scrolledTo #scrolledToElement="scrolledTo">
							</i></a>

					</h3>

					<ul *ngIf="!mobile" style="margin-bottom: 0rem">
						<button (click)="etoroInf(2)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li>
								<img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy" />

								<h5>Smart Stock Curation</h5>

								<p style="color: black">It analyses all stock trading on the NASDAQ-100 Index, from
									there it selects the Top 20
									to
									trade on a monthly rotation.</p>
							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(3)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li>
								<img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

								<h5>Advanced Analytics & Intelligence</h5>

								<p style="color: black">Each month the algorithm updates the Top 20 for the coming
									month. Selecting the Top 20
									provides diversification within the portfolio.</p>
							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(4)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li>
								<img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

								<h5>Diversified Approach</h5>

								<p style="color: black">This diversification reduces risk exposure whilst targeting
									a net-profit of 15 – 45%.</p>
							</li>
						</button>
					</ul>

					<ul *ngIf="mobile" style="margin-bottom: 0rem">
						<button (click)="etoroInf(2)" id="SmartStock" type="button" class="landingBtn btn-primary"
							style="padding-top: 1%; padding-bottom: 1%">
							<li class="padTopMobileButton">

								<img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy" />

								<h5 style="line-height: 96%">Smart Stock Curation</h5>

								<p style="color: black">It analyses all stock trading on the NASDAQ-100 Index, from
									there it selects the Top 20
									to
									trade on a monthly rotation.</p>

							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(3)" id="SmartStock" type="button" class="landingBtn btn-primary"
							style="padding-top: 1%; padding-bottom: 1%">
							<li class="padTopMobileButton">

								<img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

								<h5 style="line-height: 96%">Advanced Analytics & Intelligence</h5>

								<p style="color: black">Each month the algorithm updates the Top 20 for the coming
									month. Selecting the Top 20
									provides diversification within the portfolio.</p>

							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(4)" id="SmartStock" type="button" class="landingBtn btn-primary"
							style="padding-top: 1%; padding-bottom: 1%">
							<li class="padTopMobileButton">

								<img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

								<h5 style="line-height: 96%">Diversified Approach</h5>

								<p style="color: black">This diversification reduces risk exposure whilst targeting
									a net-profit of 15 – 45%.</p>

							</li>
						</button>

						<li style="margin-top: 2rem">
							<a (click)="etoroInf(1)" id="Etoro"><img src="../../assets/img/1280px-FXCM_logo.svg.png"
									loading="lazy" alt="Click here for more eToro information" class="etoroBtnHowDesk"
									style="padding-top: 5%; width: 50%"></a>
						</li>
					</ul>
					<div *ngIf="!mobile">
						<a (click)="etoroInf(1)" id="Etoro"><img src="../../assets/img/1280px-FXCM_logo.svg.png"
								loading="lazy" alt="Click here for more eToro information"
								class="section__icon etoroBtnHowDesk" style="width: 20%"></a>
					</div>
					<!-- <div *ngIf="mobile" class="etoroBtnPosMob">
						<a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/svg/section-icon-1.svg" loading="lazy"
								alt="Click here for more eToro information" class="etoroBtnHowDesk"></a>
					</div> -->

				</div><!-- /.section__content -->
			</div><!-- /.shell -->
		</section>
		<section class="section" #screen id="mainGraph" style="" *ngIf="!mobile">
			<div class="shell shell--size-3" style="height: 100%">
				<div class="row mb-2">
					<div class="col" style="text-align: center;">
						<h2 style="margin-bottom: 2%">The Types of Algorithms we Develop</h2>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col mr-2">
						<a href="https://drive.google.com/file/d/14W7DDJdaYDpwu0vPxJ88Z5BHuxoPy8LE/view"
							target="_blank"><img class="typesGrid"
								src="https://cosmicmedia-a0ce.restdb.io/media/Algo1.png" /></a>
					</div>
					<div class="col mr-2 ml-2">
						<a href="https://drive.google.com/file/d/14XNrDOIvhi1hsfLJTtL9e-wyvlvHgnN9/view"
							target="_blank"><img class="typesGrid"
								src="https://cosmicmedia-a0ce.restdb.io/media/Algo2.png" /></a>
					</div>
					<div class="col ml-2">
						<a href="https://drive.google.com/file/d/14m7ZCJtQCcEbuMAqiqR42ADer0kjTZQV/view"
							target="_blank"><img class="typesGrid"
								src="https://cosmicmedia-a0ce.restdb.io/media/Algo3.png" /></a>
					</div>
				</div>

				<div class="row">
					<div class="col mr-2">
						<a href="https://drive.google.com/file/d/147Tf347XKBk_0HP0d5IUETugFaRBiRsL/view"
							target="_blank"><img class="typesGrid"
								src="https://cosmicmedia-a0ce.restdb.io/media/Algo4.png" /></a>
					</div>
					<div class="col mr-2 ml-2">
						<a href="https://drive.google.com/file/d/14Zf-b4pLdEMjpQTiXeeVp5RbmM9qDbA8/view"
							target="_blank"><img class="typesGrid"
								src="https://cosmicmedia-a0ce.restdb.io/media/Algo5.png" /></a>
					</div>
					<div class="col ml-2">
						<a href="https://drive.google.com/file/d/1iqW5I1Rvx45txJ61DibrnmuKxY-Sk1_q/view"
							target="_blank"><img class="typesGrid"
								src="https://cosmicmedia-a0ce.restdb.io/media/Algo6.png" /></a>
					</div>
				</div>

			</div><!-- /.shell -->
		</section>

		<div class='carousel-wrapper' style="margin-top: 5%" *ngIf="mobile">
			<h2 style="text-align: center; margin-bottom: 2%">The Types of Algorithms we Develop</h2>
			<!-- Pagination Display -->
			<div class="pagination">
				<span *ngFor="let num of slideNumbers; let i = index" [class.active]="currentSlide === i + 1"
					(click)="scrollToSlide(i)">
					{{ i + 1 }}
				</span>
			</div>



			<ul class='carousel x mandatory' #carousel>
				<li class="bg-white">
					<div class="row cardItem">
						<div class="col">
							<div class="card" style="padding: 15px 15px 15px 15px;">
								<button style="border: none"><a
										href="https://drive.google.com/file/d/14W7DDJdaYDpwu0vPxJ88Z5BHuxoPy8LE/view"><img
											class="card-img-top mobileImages"
											src="https://cosmicmedia-a0ce.restdb.io/media/Algo1.png"
											alt="Card image cap"></a></button>

							</div>
						</div>
					</div>
				</li>
				<li class="bg-white">
					<div class="row cardItem">
						<div class="col">
							<div class="card" style="padding: 15px 15px 15px 15px;">
								<button style="border: none"><a
										href="https://drive.google.com/file/d/14XNrDOIvhi1hsfLJTtL9e-wyvlvHgnN9/view"><img
											class="card-img-top mobileImages"
											src="https://cosmicmedia-a0ce.restdb.io/media/Algo2.png"
											alt="Card image cap"></a></button>

							</div>
						</div>
					</div>
				</li>
				<li class="bg-white">
					<div class="row cardItem">
						<div class="col">
							<div class="card" style="padding: 15px 15px 15px 15px;">
								<button style="border: none"><a
										href="https://drive.google.com/file/d/14m7ZCJtQCcEbuMAqiqR42ADer0kjTZQV/view"><img
											class="card-img-top mobileImages"
											src="https://cosmicmedia-a0ce.restdb.io/media/Algo3.png"
											alt="Card image cap"></a></button>

							</div>
						</div>
					</div>
				</li>
				<li class="bg-white">
					<div class="row cardItem">
						<div class="col">
							<div class="card" style="padding: 15px 15px 15px 15px;">
								<button style="border: none"><a
										href="https://drive.google.com/file/d/147Tf347XKBk_0HP0d5IUETugFaRBiRsL/view"><img
											class="card-img-top mobileImages"
											src="https://cosmicmedia-a0ce.restdb.io/media/Algo4.png"
											alt="Card image cap"></a></button>

							</div>
						</div>
					</div>
				</li>
				<li class="bg-white">
					<div class="row cardItem">
						<div class="col">
							<div class="card" style="padding: 15px 15px 15px 15px;">
								<button style="border: none"><a
										href="https://drive.google.com/file/d/14Zf-b4pLdEMjpQTiXeeVp5RbmM9qDbA8/view"><img
											class="card-img-top mobileImages"
											src="https://cosmicmedia-a0ce.restdb.io/media/Algo5.png"
											alt="Card image cap"></a></button>

							</div>
						</div>
					</div>
				</li>
				<li class="bg-white">
					<div class="row cardItem">
						<div class="col">
							<div class="card" style="padding: 15px 15px 15px 15px;">
								<button style="border: none"><a
										href="https://drive.google.com/file/d/1iqW5I1Rvx45txJ61DibrnmuKxY-Sk1_q/view"><img
											class="card-img-top mobileImages"
											src="https://cosmicmedia-a0ce.restdb.io/media/Algo6.png"
											alt="Card image cap"></a></button>

							</div>
						</div>
					</div>
				</li>

			</ul>
			<div class='position x mandatory'></div>
		</div>

		<section class="section" style="margin-top: 5%" #nsdq id="performance" *ngIf="!mobile">
			<div class="shell shell--size-3" style="height: 100%" style="text-align: center;">
				<div class="row mb-4">
					<div class="col">
						<h2>Backtesting our most recent Algorithm</h2>
					</div>
				</div>
				<div class="row">
					<div class="col" style="text-align: left;">
						WFA Test AA-12 (TICKS), Zorro 2.444
					</div>
				</div>
				<div class="row mb-3">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W-StGsCTiaig5rPS714YRS3w5OuRPfUq/view"
							target="_blank"><img class="typesGridOutside"
								src="https://cosmicmedia-a0ce.restdb.io/media/backtesting1.png"
								style="width: 100%" /></a>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W-StGsCTiaig5rPS714YRS3w5OuRPfUq/view"
							target="_blank"><img class="typesGridOutside"
								src="https://cosmicmedia-a0ce.restdb.io/media/backtesting2.png" /></a>
					</div>
				</div>
			</div><!-- /.shell -->
		</section>

		<section class="section" style="margin-top: 3%; margin-bottom: 3%" #nsdq id="performance" *ngIf="mobile">
			<div class="shell shell--size-3" style="height: 100%" style="text-align: center;">
				<div class="row mb-4">
					<div class="col">
						<h2 style="margin-bottom: 3%">Backtesting our most recent Algorithm</h2>
					</div>
				</div>
				<div class="row">
					<div class="col" style="text-align: left;">
						WFA Test AA-12 (TICKS), Zorro 2.444
					</div>
				</div>
				<div class="row mb-3">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W-StGsCTiaig5rPS714YRS3w5OuRPfUq/view"
							class="mobileImages anchorSize"><img
								src="https://cosmicmedia-a0ce.restdb.io/media/backtesting1.png"
								style="width: 100%" /></a>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W-StGsCTiaig5rPS714YRS3w5OuRPfUq/view"
							class="mobileImages anchorSize"><img
								src="https://cosmicmedia-a0ce.restdb.io/media/backtesting2.png" /></a>
					</div>
				</div>
			</div><!-- /.shell -->
		</section>

		<section class="section" style="margin-top: 5%" #exe id="exe" *ngIf="!mobile">
			<div class="shell shell--size-3" style="height: 100%; text-align: center;">
				<div class="row mb-2">
					<div class="col">
						<h2>Demo / Paper Account Portfolio - FXCM</h2>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W-StGsCTiaig5rPS714YRS3w5OuRPfUq/view"
							target="_blank"><img class="typesGridOutside"
								src="https://cosmicmedia-a0ce.restdb.io/media/demo-portfolio.png"
								style="width: 100%" /></a>
					</div>
				</div>
			</div><!-- /.shell -->
		</section>
		<section class="section" #exe id="exe" style="margin-bottom: 3%" *ngIf="mobile">
			<div class="shell shell--size-3" style="height: 100%; text-align: center;">
				<div class="row mb-2">
					<div class="col">
						<h2 style="margin-bottom: 3%">Demo / Paper Account Portfolio - FXCM</h2>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W-StGsCTiaig5rPS714YRS3w5OuRPfUq/view"
							class="mobileImages anchorSize"><img
								src="https://cosmicmedia-a0ce.restdb.io/media/demo-portfolio.png"
								style="width: 100%" /></a>
					</div>
				</div>
			</div><!-- /.shell -->
		</section>
		<section class="section" style="margin-top: 5%" #exe id="exe" *ngIf="!mobile">
			<div class="shell shell--size-3" style="height: 100%; text-align: center;">
				<div class="row mb-2">
					<div class="col">
						<h2>Demo / Paper Account - Live Trading - FXCM</h2>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W0ZcxlyKWPQ3SMNm6mNa7A_9tbtDeeJQ/view"
							target="_blank"><img class="typesGridOutside"
								src="https://cosmicmedia-a0ce.restdb.io/media/demo-trading.png"
								style="width: 100%;" /></a>
					</div>
				</div>
			</div><!-- /.shell -->
		</section>

		<section class="section" #exe id="exe" style="margin-bottom: 3%" *ngIf="mobile">
			<div class="shell shell--size-3" style="height: 100%; text-align: center;">
				<div class="row mb-2">
					<div class="col">
						<h2 style="margin-bottom: 3%">Demo / Paper Account - Live Trading - FXCM</h2>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a href="https://drive.google.com/file/d/1W0ZcxlyKWPQ3SMNm6mNa7A_9tbtDeeJQ/view"
							class="mobileImages anchorSize"><img
								src="https://cosmicmedia-a0ce.restdb.io/media/demo-trading.png"
								style="width: 100%;" /></a>
					</div>
				</div>
			</div><!-- /.shell -->
		</section>

		<section class="section mainSpacing" #screen id="mainGraph"
			style="height: 70vh; margin-top: 3%; margin-bottom: 3%">
			<div class="shell shell--size-3" style="height: 100%">
				<br />
				<div class="row chart" id="chartSize">
					<div class="col">
						<!-- <div class="chart__head hidden-xs"> -->
						<div class="chart__head">
							<div class="chart__head-content">
								<!-- <h6>eToro Analysis</h6> -->

								<h6>Cosmic Algorithm Ltd.</h6>

								<span style="font-size: x-small" *ngIf="mobile">LIVE: {{DynamUpd}}</span><br />
								<span style="font-size: small" *ngIf="!mobile">LIVE: {{DynamUpd}}</span><br />
								<!-- <span>Last Updated: {{updateRecent}}</span> -->
							</div><!-- /.chart__head-content -->

						</div><!-- /.chart__head -->
					</div>
					<div *ngIf="!mobile" class="col legendGrad legendShadow" id="legend">
						<div id="legendItems">
							<div class="row margBottomLegend">
								<div class="col">AGR +/- (Since Oct 2022)</div>
								<div class="col"><span id="tLaunch"><span *ngIf="lPos">+</span>{{last}}%</span>
								</div>
							</div>
							<div class="row margBottomLegend">
								<div class="col">Gain +/- (Since Oct 2022)</div>
								<div class="col"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{perfLaunch}}%</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="mobile" class="row legendGrad legendShadow" id="legend" style="width: 93%;margin: auto;">
					<div id="legendItems">
						<div class="row margBottomLegend">
							<div class="col">AGR +/- (Since Oct 2022)</div>
							<div class="col-auto legendPadMob"><span id="tLaunch"><span
										*ngIf="lPos">+</span>{{last}}%</span></div>
						</div>
						<div class="row margBottomLegend">
							<div class="col">Gain +/- (Since Oct 2022)</div>
							<div class="col-auto legendPadMob"><span id="tNSDQ"><span
										*ngIf=nPos>+</span>{{perfLaunch}}%</span></div>
						</div>
					</div>
				</div>
				<br />
				<div class="row chart" style="height: 100%">
					<div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart"
						style="height: 100%">
						<div id="container" class="textCenter">
						</div><!-- /.chart__body -->
					</div>
				</div>
			</div><!-- /.shell -->
		</section>

		<div style="text-align: center; font-size:smaller" *ngIf="!mobile"><br /><br />Past performance is not an
			indication of
			future results.<br /><br /><br /></div>
		<div style="text-align: center; margin-left: 2vw; font-size: smaller;" *ngIf="mobile">
			<br /><br /><br /><br /><br /><br /><br /><br /><br />Past performance is not an
			indication of future results.<br /><br /><br />
		</div>
		<br />

		<app-main-portfolio></app-main-portfolio>

		<section class="section-circles" *ngIf="!mobile" id="bubbles">
			<div class="shell shell--size-5">
				<div class="section__inner">
					<div class="section__head">
						<h4 class="circlesTitle">Method</h4>

						<h4 class="wow fadeInRight" data-wow-delay=".2s">Cosmic Algorithm summarily lists the
							analytical methodologies for this algorithm</h4>
					</div><!-- /.section__head -->

					<div class="section__content">
						<ul>
							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Performance and Profitability
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Risk and Drawdown Management
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Trading Volume and Execution Metrics
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Transaction Costs and Efficiency
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Market Performance and Portfolio Diversification
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Walk-Forward Optimisation and Strategy Resilience
							</li>
							<li class="wow fadeInRight" data-wow-delay=".2s">
								<a (click)="etoroInf(5)" id="Methodology">
									<i [class.hovered]="scrolledToElement.reachedBubbles"
										class="fa-solid fa-circle-info fa-3x circlesI" placement="top"
										ngbTooltip="Read More" tooltipClass="toolTips" scrolledTo
										#scrolledToElement="scrolledTo">
									</i></a>
							</li>
						</ul>
					</div><!-- /.section__content -->
					<div class="section__foot" style="display: flex;
    				align-items: center;">
						<div>
							<h6 class="wow fadeInRight white" data-wow-delay=".2s">Get started with </h6>

							<h2 class="wow fadeInRight white" data-wow-delay=".2s">US $200</h2>


							<br />
							<div style="font-size: smaller;
								margin-top: 1vh;
								width: 100%;" class="wow fadeInRight white" data-wow-delay=".2s">
								<div style="padding-left: 10%;padding-right: 10%;">Past performance is not an indication
									of future results.</div>
							</div>
						</div>
					</div><!-- /.section__foot -->
				</div><!-- /.section__inner -->
			</div><!-- /.shell -->
		</section><!-- /.section-circles -->

		<section class="section-circles" *ngIf="mobile" id="bubbles">
			<div class="shell shell--size-5">
				<div class="section__inner">
					<div class="section__head">
						<h4 class="circlesTitle">Method</h4>

						<h4 class="wow fadeInRight" data-wow-delay=".2s">Cosmic Algorithm summarily lists the
							analytical methodologies for this algorithm</h4>
					</div><!-- /.section__head -->

					<div class="section__content">
						<ul class="circlesMarg">
							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Performance and Profitability
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Risk and Drawdown Management
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Trading Volume and Execution Metrics
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Transaction Costs and Efficiency
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Market Performance and Portfolio Diversification
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Walk-Forward Optimisation and Strategy Resilience
							</li>
							<li>
								<a (click)="etoroInf(5)" class="circlesIMob" id="Methodology">
									<i class="fa-solid fa-circle-info fa-3x circlesIMob2"
										[class.hovered]="scrolledToElement.reachedBubbles" scrolledTo
										#scrolledToElement="scrolledTo">
									</i></a>
							</li>
						</ul>
					</div><!-- /.section__content -->
					<div class="section__foot footerSize" style="display: flex;
    				align-items: center;">
						<div>

							<h6 class="wow fadeInRight white" data-wow-delay=".2s">Get started with </h6>

							<h2 class="wow fadeInRight white" data-wow-delay=".2s">US $200</h2>

							<div style="text-align: center; font-size: smaller;" class="wow fadeInRight white"
								data-wow-delay=".2s"><br />Past performance is not an indication of future results.
							</div>
						</div>
					</div><!-- /.section__foot -->
				</div><!-- /.section__inner -->
			</div><!-- /.shell -->
		</section><!-- /.section-circles -->
		<section class="section-secondary" id="brochure">
			<div class="shell shell--size-7">
				<div class="section__inner">
					<div class="section__background"></div><!-- /.section__background -->

					<div class="section__image" class="wow fadeInUp" data-wow-delay=".5s">
						<div class="brochurePos">
							<img src="assets/img/temp/section-img-2.png" loading="lazy"
								alt="Image of Backseat-Trader algorithm's brochure">
						</div>
					</div><!-- /.section__image -->

					<div class="section__content">
						<h3>Algorithmic trading handbook on trading without trading.</h3>

						<p>Take a copy of the brochure to review and share</p>
						<!-- 
						<a href="https://drive.google.com/uc?export=download&id=1bIO4A-rcZLejbLXYVn-M0A_DBQQMz8TI" class="btn btn--dark">Download Now</a> -->
						<div *ngIf="!loading">
							<a href="https://drive.google.com/file/d/1UJoMYFBVQtwMAzv5j0Uq-Fr8cj4HcJJN/view"
								target="_blank" class="btn btn--dark">Download Now</a>
						</div>
						<div *ngIf="loading">
							<div *ngIf="loading" class="text-center">
								<div class="spinner-grow text-primary" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div><!-- /.section__content -->
				</div><!-- /.section__inner -->
			</div><!-- /.shell -->
		</section><!-- /.section-secondary -->
	</div><!-- /.wrapper -->

	<div class="modal" id="myModal">
		<div class="modal-dialog modal-fullscreen">
			<div class="modal-content">


				<div class="modal-body">
					<video height="95%" width="100%" controls #homeVideo>
						<source src="https://theapi.backseat-trader.com/Introducing-eToro.mp4" type="video/mp4">
					</video>
				</div>

				<!-- Modal footer -->
				<div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
					<button type="button" class="btn btn-danger" data-bs-dismiss="modal"
						(click)="close(homeVideo)">Close</button>
				</div>

			</div>
		</div>
	</div>
	<div class="fb-like hideIt" data-href="https://www.facebook.com/backseattrader" data-width="" data-layout=""
		data-action="" data-size="" data-share="true"></div>

	<script src="assets/vendor/jquery-3.6.0.min.js"></script>
	<!--<script src="assets/js/bundle.js"></script>-->
</body>

<div class="modal" id="myModal">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">


			<div class="modal-body">
				<video height="95%" width="100%" controls #homeVideo>
					<source src="https://theapi.backseat-trader.com/Introducing-eToro.mp4" type="video/mp4">
				</video>
			</div>

			<!-- Modal footer -->
			<div class="modal-footer" style="    margin: auto;
			margin-bottom: 1%;
			margin-top: -1%;">
				<button type="button" class="btn btn-danger" data-bs-dismiss="modal"
					(click)="close(homeVideo)">Close</button>
			</div>

		</div>
	</div>
</div>

</html>